export default __webpack_public_path__ + "static/media/explore-background.6bb39784.jpg";